import { skipToken, useQuery } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";
import useAuth from "$src/core/hooks/use-auth";

type Variables = {
  profileId: string;
};

export const queryKey = (variables: Variables) => ["watchlist", variables];

const useWatchlistQuery = () => {
  const { profile } = useAuth();
  const { api } = useApi();

  return useQuery({
    queryKey: queryKey({ profileId: profile?.id ?? "" }),
    queryFn: profile?.id ? () => api.getWatchlist(profile.id) : skipToken,
  });
};

export default useWatchlistQuery;
